export default "__VITE_ASSET__e3236bab__"